export function formatClassName(ctor) {
    return String(ctor['name'] || ctor);
}
//# sourceMappingURL=format-class-name.js.map